
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E3BFF8","d":"M40.1 24.5l14.16 9.42c.04-.56.17-1.1.17-1.7A22.22 22.22 0 1032.2 54.46c.24 0 .47-.06.7-.06V28.37c0-3.7 4.13-5.93 7.19-3.86z"}}),_c('path',{attrs:{"fill":"#A127E8","fill-rule":"evenodd","d":"M32.91 28.37c0-3.7 4.1-5.93 7.19-3.86l14.16 9.44v-.03l13.67 9.09a4.6 4.6 0 010 7.68L40.1 69.23a4.63 4.63 0 01-7.19-3.86v-37z","clip-rule":"evenodd"}})])
          )
        }
      }
    